module.exports = __webpack_public_path__ + "static/img/大疆AVINOX DRIVER SYSTEM（山地车助力系统）.78d249dc.png";